<template>
  <div class="main-row">
    <div class="left-column">
      <div class="infobox">
        <h4>Steg 1 av 2</h4>
        <p>Først trenger vi litt informasjon om deg.</p>
        <p>Vennligst fyll ut feltene i skjemaet.</p>
        <p>Du vil få mulighet til å teste ulike valg senere.</p>
      </div>
    </div>
    <div class="right-column">
      <v-form v-model="valid" class="form">
        <v-text-field
          v-model="user.salary"
          :rules="rules.salary"
          label="Din årslønn, inkludert bonus og overtid"
          hint="F.eks 500000"
          required
          prepend-icon="local_atm"
        ></v-text-field>

        <v-text-field
          v-model="user.years_in_it"
          :rules="rules.years_in_it"
          required
          label="Antall år i IT-bransjen"
          prepend-icon="timeline"
          hint="Inkluderer ikke utdanning"
        ></v-text-field>

        <v-text-field
          v-model="user.work_percentage"
          :rules="rules.work_percentage"
          required
          label="Stillingsbrøk i prosent"
          prepend-icon="pie_chart"
          hint="Hvis du jobber fulltid skal denne være 100"
        ></v-text-field>

        <br><v-btn :disabled="!valid" to="/form-final" block color="primary">gå videre<v-icon>navigate_next</v-icon></v-btn>
      </v-form>

    </div>
  </div>
</template>

<script>
  export default {
    props: { 
      user: Object 
    },
    data: () => ({
      valid: true,
      rules: {
        salary: [
          val => !!val || 'Denne må fylles ut',
          val => val < 10000000 || 'Fyll inn din virkelige lønn i hele tall'
        ],
        years_in_it: [
          val => !!val || 'Denne må fylles ut',
          val => val < 80 || 'Så gammel er du vel ikke?'
        ],
        work_percentage: [
          val => !!val || 'Denne må fylles ut',
          val => val < 200 || 'Jobber du virkelig så mye?'
        ]
      }
    })
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Form.vue